const SpotifyWebApi = require('spotify-web-api-js')

export const Spotify = new SpotifyWebApi()



// WEBPACK FOOTER //
// ./src/core/Spotify.js